module.exports = __webpack_public_path__ + "img/primer-dia-179-edit.59949603.jpg";